module.exports = __webpack_public_path__ + "static/media/moschino_portachiavi.aa244c15.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/moschino_portachiavi.png
// module id = 801
// module chunks = 0